exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.general_card[data-v-69856eaa] {\n    width: 280px!important;\n}\n/*Mobile version*/\n@media screen and (max-width: 800px) {\n.general_card[data-v-69856eaa] {\n        width: 240px!important;\n}\n}\n", ""]);

// exports
